import { useProfile } from "@brg/auth";

const RATING_TAG_GLOBAL_TYPES = ['student', 'hsealumni', 'employee', 'cooperator'];

export const useShowRatingCompetitionTag = (competition: any): boolean => {
    const profile = useProfile();

    if (!competition?.isSpecial) return false;

    return !!profile?.globalTypes?.some((type: string) => RATING_TAG_GLOBAL_TYPES.includes(type?.toLowerCase()));
};
import { useProfile } from "@brg/auth";

const RATING_TAG_GLOBAL_TYPES = ['student', 'hsealumni', 'employee', 'cooperator'];

export const useShowRatingCompetitionTag = (competition: any): boolean => {
    const profile = useProfile();

    if (!competition?.isSpecial) return false;

    return !!profile?.globalTypes?.some((type: string) => RATING_TAG_GLOBAL_TYPES.includes(type?.toLowerCase()));
};
